import { z } from 'zod'

import { t } from '../i18n/setting'

export const loginPasswordSchema = () =>
  z
    .string()
    .max(50, t('passwordMaxLength'))
    .min(8, t('passwordMinLength'))
    .regex(/[A-Z]/, t('passwordMustContainUppercase'))
    .regex(/[a-z]/, t('passwordMustContainLowercase'))
    .regex(/[0-9]/, t('passwordMustContainNumber'))
    .regex(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/, t('passwordMustContainSpecialChar'))
